import { getLenis } from './smoothscroll';

const STORAGE_KEY = 'splash-shown';
const HOLD_DELAY = 2600;
const HIDE_DELAY = 900;

export default function setSplash() {
  const splash = document.querySelector('.js-splash');

  if (!splash || document.documentElement.classList.contains('no-splash')) return;

  const body = document.body;
  const lenis = getLenis();

  body.classList.add('hidden');
  lenis?.stop();

  requestAnimationFrame(() => {
    splash.classList.add('is-filling');
  });

  setTimeout(() => {
    splash.classList.add('is-hidden');
    sessionStorage.setItem(STORAGE_KEY, '1');

    setTimeout(() => {
      body.classList.remove('hidden');
      lenis?.start();
    }, HIDE_DELAY);
  }, HOLD_DELAY);
}
